
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.5 9a5.5 5.5 0 00-3.047-4.927A5.5 5.5 0 106.5 14.287V15.5l-1 1 1 1v1l-1 1 1 1V22L8 23.5 9.5 22v-7.713A5.5 5.5 0 0013.5 9z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8 9.498a2 2 0 100-4 2 2 0 000 4zm1.5 5.515a5.507 5.507 0 005.425.033L16 16v1.5h1.5l.5.525V19.5h1.317l1.062 1H22.5v-2.121l-5.454-5.454a5.5 5.5 0 00-.248-5.758 5.5 5.5 0 00-5.252-2.375","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8 7V2.5a2 2 0 114 0v2.253","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    